import React from "react";
import "./page404.css";
import Lottie from "lottie-react";
import notfound from "../../json/Animation/pagenotFound.json";
import { useNavigate } from "react-router-dom";

const Page404 = () => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center items-center flex-col h-screen fixed inset-0 z-[400] bg-white">
      <Lottie
        animationData={notfound}
        loop={true}
        autoplay={true}
        style={{ width: "100%", height: "60%" }}
      />
      <button
        onClick={() => navigate("/")}
        className="text-lg font-semibold text-forging-yellow"
      >
        Back to Home Page
      </button>
    </div>
  );
};

export default Page404;
